import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";

//import services
import AuthService from "../../services/auth.service";

//import components
import HeaderComponent from "../../components/header.component";
import Footer from "../../components/footer.component";

//import assets
import { Link } from "react-router-dom";
import LegendMeetingStatus from "../../components/legend-meeting-status.component";
import Spinner from "../../components/ui/spinner.component";
import { toast } from "react-toastify";

//import datastores
import { loggedInState } from "../../data/loggedIn.atom";

export default function PinView() {
    const { t } = useTranslation();
    const [pin, setPin] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useRecoilState(loggedInState);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Assemblo - MedeMerker login";
    });

    function loginWithPin() {
        if (!pin || pin.length !== 6) {
            toast.error("Voer een 6-cijferige PIN in.");
            return;
        }

        setIsLoading(true);
        AuthService.loginPin(pin)
            .then((response) => {
                setLoggedIn(true);
                setIsLoading(false);
                navigate("/");
            })
            .catch((err) => {
                setIsLoading(false);
                // Show the actual error message from backend
                const errorMessage = err.response?.data || "Inloggen mislukt. Probeer opnieuw of contacteer ons.";
                toast.error(errorMessage);
                console.log(err);
            });
    }

    function handlePinChange(e) {
        const value = e.target.value.replace(/\D/g, ''); // Only digits
        if (value.length <= 6) {
            setPin(value);
        }
    }

    function handleKeyPress(e) {
        if (e.key === 'Enter') {
            loginWithPin();
        }
    }

    return (
        <section className="bg-gray-50 mx-auto h-full">
            <HeaderComponent
                text={t("home.header.publicheader")}
                subtext={t("home.header.publicsub")}
                name={""}
                explainer
            />
            <main className="w-full mx-auto absolute -mt-80 z-30">
                <div className="w-11/12 max-w-3xl mx-auto py-6 sm:px-6 lg:px-8 s">
                    <div className="px-4 py-6 sm:px-0 bg-white rounded-2xl shadow-md">
                        <section className="text-center px-10 lg:px-20">
                            <div className="relative">
                                <h1 className="text-3xl font-semibold text-gray-900 pt-10">
                                    MedeMerker login
                                </h1>
                                <h1 className="text-3xl font-semibold text-gray-900">-</h1>
                                <p className="text-gray-900">
                                    Voer je 6-cijferige PIN-code in om in te loggen
                                </p>
                                <div>
                                    <div className="mt-8 flex justify-center space-x-3">
                                        {[0, 1, 2, 3, 4, 5].map((index) => (
                                            <div
                                                key={index}
                                                className="w-12 h-12 bg-slate-100 rounded-lg border-2 border-gray-300 focus-within:border-indigo-500 flex items-center justify-center cursor-pointer hover:bg-slate-200 transition-colors"
                                                onClick={() => document.getElementById('pin').focus()}
                                            >
                                                <span className="text-2xl font-bold text-gray-800">
                                                    {pin[index] ? '●' : ''}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                    <input
                                        type="text"
                                        name="pin"
                                        id="pin"
                                        className="sr-only"
                                        onChange={handlePinChange}
                                        onKeyDown={handleKeyPress}
                                        value={pin}
                                        maxLength="6"
                                        inputMode="numeric"
                                        autoFocus
                                    />
                                </div>
                                <div className="block mt-18">
                                    {!isLoading ?
                                        <Link
                                            onClick={loginWithPin}
                                            className="button-primary inline-block w-max text-white mt-10 mb-14"
                                        >
                                            Inloggen
                                        </Link>
                                        :
                                        <div className="mt-10 mb-14">
                                            <Spinner />
                                        </div>
                                    }
                                </div>
                                <div className="mt-2 mb-8">
                                    <Link
                                        to="/"
                                        className="text-sm text-gray-600 underline"
                                    >
                                        ← Terug naar normale login
                                    </Link>
                                </div>
                            </div>
                        </section>
                        <section className="flex bg-slate-100 flex-col text-center -mb-6 rounded-bl-2xl rounded-br-2xl" >
                            <p className="mt-8 mb-4">{t("auth.rsvp")}:</p>{" "}
                            <LegendMeetingStatus />
                        </section>
                    </div>
                    <Footer limited={true} />
                </div>
            </main>
        </section>
    );
}